import { DECIMAL_EPSILON, stripFloatNoise } from './decimal';

/** The orderbook rejects any order below one contract, fractional or not. */
export const MIN_ORDER_QUANTITY = 1;

export const isQuantitySettled = (quantity: number): boolean =>
  Math.abs(quantity) <= DECIMAL_EPSILON;

export const hasEnoughQuantity = (available: number, required: number): boolean =>
  available >= required - DECIMAL_EPSILON;

export const isOrderQuantityAllowed = (quantity: number): boolean =>
  Number.isFinite(quantity) && hasEnoughQuantity(quantity, MIN_ORDER_QUANTITY);

export const settleQuantity = (quantity: number): number =>
  isQuantitySettled(quantity) ? 0 : quantity;

export const toWholeQuantity = (quantity: number): number =>
  Math.max(Math.floor(stripFloatNoise(quantity)), 0);
